// extracted by mini-css-extract-plugin
module.exports = {"container":"Buttons_container_fwVro","fullWidth":"Buttons_fullWidth_33aLH","centered":"Buttons_centered_27cWa"};